module.exports = __webpack_public_path__ + "static/media/home-ec.6fd84273.jpg";